import * as React from 'react';

const House = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={22} height={22} viewBox="0 0 22 22" {...props}>
        <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.3}>
            <path
                strokeWidth={1.191671}
                d="M3.438 16.5v3.438a1.375 1.375 0 0 0 1.374 1.375h4.126v-5.5a1.375 1.375 0 0 1 1.374-1.376h1.376a1.375 1.375 0 0 1 1.374 1.376v5.5h4.126a1.375 1.375 0 0 0 1.375-1.375V16.5"
            />
            <path strokeWidth={1.191671} d="m.688 15.125 9.34-9.34a1.375 1.375 0 0 1 1.945 0l9.34 9.34" />
            <path
                strokeWidth={1.191671}
                d="M15.125 8.938V7.562h3.438v4.813M15.695.688l-.373.497a.96.96 0 0 0 .147 1.317h0a.96.96 0 0 1 .146 1.316l-.373.498M19.133.688l-.373.497a.96.96 0 0 0 .146 1.317h0a.96.96 0 0 1 .147 1.316l-.373.498"
            />
        </g>
    </svg>
);
export default House;
